import { FaRegImage } from "react-icons/fa6";
import TemplateModal from "../TemplateModal";
import { toast, Bounce } from "react-toastify";
import { GrDocumentText } from "react-icons/gr";
import React, { useRef, useState } from "react";
import { HiOutlineCamera } from "react-icons/hi2";
import { MdOutlineAddPhotoAlternate } from "react-icons/md";
import axios from "axios";
import Cookies from "js-cookie";
import CONSTANTS from "src/components/services/api";

const AttachmentComponent = ({
  close,
  loading,
  setShowCamera,
  setLoading,
  handleUpload,
  setInputValue,
}) => {
  const bearerToken = Cookies.get("Token")
  const fileInputRef = useRef(null);
  const [openTemplate, setOpenTemplate] = useState(false);

  const openFilePicker = (picketType) => {
    // close();
    if (picketType == "image&video") {
      fileInputRef.current.accept = "image/*,video/*";
    } else if (picketType == "doc") {
      fileInputRef.current.accept =
        ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt";
    }
    fileInputRef.current.click();
  };

  const attachmentClose = () => {
    close();
  };

  const onFileChange = async (e) => {
    const file = e.target.files[0];;
    if (file.type.startsWith("video/")) {
      let thumb = await generateThumbnail(file);
      const newFormData = new FormData();
      newFormData.append("file[]", e.target.files[0]);
      newFormData.append("file_id", "95345234gsdg395");
      newFormData.append("subscription_id", "29674");
      newFormData.append("thumbnail[]", thumb);
      try {
        setLoading(true);
        const response = await axios.post(
          `${CONSTANTS.API_BASE}/uploadmultiplechatmediaProd`,
          newFormData,
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              Authorization: bearerToken,
            },
          }
        );
        handleUpload(response.data);
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error(error?.message || "Error to upload the media", {
          position: "top-center",
          autoClose: 1000,
          transition: Bounce,
        });
      } finally {
        close();
        setLoading(false);
      }
    } else {
      const newFormData = new FormData();
      newFormData.append("file[]", e.target.files[0]);
      newFormData.append("file_id", "95345234gsdg395");
      newFormData.append("subscription_id", "29674");
      try {
        setLoading(true);
        const response = await axios.post(
          `${CONSTANTS.API_BASE}/uploadmultiplechatmediaProd`,
          newFormData,
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              Authorization: bearerToken,
            },
          }
        );
        handleUpload(response.data);
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error(error?.message || "Error to upload the media", {
          position: "top-center",
          autoClose: 1000,
          transition: Bounce,
        });
      } finally {
        close();
        setLoading(false);
      }
    }
  };

  const generateThumbnail = (videoFile) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const url = URL.createObjectURL(videoFile);
      video.src = url;

      // Once the video metadata is loaded (like duration and dimensions)
      video.onloadedmetadata = () => {
        // Set video dimensions for the canvas
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        // Seek to the middle of the video to capture the thumbnail
        video.currentTime = video.duration / 2;
      };

      // Once the video has loaded the current frame at currentTime, capture the frame
      video.onseeked = () => {
        // Draw the video frame to the canvas
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        // Convert the canvas to a data URL (base64 encoded image)
        const thumbnailDataUrl = canvas.toDataURL("image/png");
        resolve(thumbnailDataUrl);

        // Clean up
        URL.revokeObjectURL(url);
      };
    });
  };

  const handleCloseTemplate = () => {
    setOpenTemplate(false);
    close();
  };

  return (
    <div>
      <div
        className={`${
          loading ? "hidden" : "flex"
        } flex-col justify-between cursor-pointer `}
      >
        <div
          onClick={setShowCamera}
          className="flex text-sm font-normal items-center gap-x-2 border-b border-[#F0F0F0] py-3 px-3"
        >
          <img
            src="/icons/camera_icon.png"
            style={{ width: "24px", height: "24px" }}
          />
          <p>Camera</p>
        </div>

        <div
          onClick={() => openFilePicker("image&video")}
          className="flex text-sm font-normal items-center gap-x-2 border-b border-[#F0F0F0] py-3 px-3"
        >
          <img
            src="/icons/photos_videos_icon.png"
            style={{ width: "24px", height: "24px" }}
          />
          <p>Photos & Videos</p>
        </div>

        <div
          onClick={() => setOpenTemplate(true)}
          className="flex text-sm font-normal items-center gap-x-2 border-b border-[#F0F0F0] py-3 px-3"
        >
          <img
            src="/icons/Template_icon.png"
            style={{ width: "24px", height: "24px" }}
          />
          <p>Template</p>
        </div>

        <div
          onClick={() => openFilePicker("doc")}
          className="flex text-sm font-normal items-center gap-x-2  py-3 px-3"
        >
          <img
            src="/icons/document_icon.png"
            style={{ width: "24px", height: "24px" }}
          />
          <p>Documents</p>
        </div>
      </div>

      <input
        type="file"
        ref={fileInputRef}
        className="hidden"
        onChange={(e) => onFileChange(e)}
        multiple
      />
      {openTemplate && (
        <TemplateModal
          open={openTemplate}
          close={handleCloseTemplate}
          setInputValue={setInputValue}
        />
      )}
    </div>
  );
};

export default AttachmentComponent;
